import { React, useState, useRef, useEffect } from 'react';
import styled, { css } from "styled-components";
import Loader from "../Loader";
import { authorizedHttpGet, authorizedHttpPost } from '../../api/httpCalls';
import { FlexWrapper, ParentDiv } from '../../styles/WrapperStyles'
import previous_inctive from '../../assests/arrow_back_grey.png';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import PageModal from "../modals/PageModal";
import { BaseButton } from '../../styles/ButtonStyles';
import EmptyView from '../EmptyView';
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import '../styles/ImageRating.css';


const BottomBarWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`;

const HeaderTextView = styled.span`
    font-family:'Gilory-Semi';
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #d7d7d7;
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `}
    ${props =>
        props.selected &&
        css`
        color: #767676;
        font-family: 'Gilory-Bold';
      `}
    ${props =>
        props.cursor &&
        css`
        cursor: pointer;
      `}
`;


const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;

const HeaderWrapper = styled(FlexWrapper)`
font-family: 'Gilory-Semi';
    // display: inline;
    margin-left: 250px;
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

const CircleStyle = styled.div`
    width: 50px;
    height: 50px;
    background-color: #d7d7d7;
    border-radius: 50%;
    text-align: center;
    line-height: 50px;
    color: black;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    ${props =>
        props.selected &&
        css`
        background-color: #4DA954;
        color: white;
      `}

`;



const ImageRating = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const handleLeftNavAppChange = (name) => {
        setAppName(name)
    };

    const [isLoading, setIsLoading] = useState(false);
    const [images, setImages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [togglePageModal, setTogglePageModal] = useState(false);
    const itemsPerPage = 1;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const [apiPageChange, setApiPageChange] = useState(1);
    const endIndex = startIndex + itemsPerPage;
    const currentProfile = images.slice(startIndex, endIndex);
    const totalPages = Math.ceil(images.length / itemsPerPage);
    const [gender, setGender] = useState('Male')
    const apiPage = useRef(1);
    const apiTotalPages = useRef(1);
    const [ratedImages, setRatedImages] = useState([]);
    const ratings = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    const decimalRatings = [1.5, 2.5, 3.5, 4.5, 5.5, 6.5, 7.5, 8.5, 9.5]
    const [displayReviewPage, setDisplayReviewPage] = useState(false);
    const shortCutRatingKeys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
    const [tenRatedImages, setTenRatedImages] = useState([]);

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (shortCutRatingKeys.includes(event.key)) {
                if (togglePageModal) {
                    return;
                }
                let rating = event.key === "0" ? 10 : parseInt(event.key);
                assignRating(rating, "shortcut");
            }
            if (event.key === 'ArrowLeft' && currentPage > 1) {
                if (currentPage > 1) { setCurrentPage(currentPage - 1) }
            } else if (event.key === 'ArrowRight' && currentPage < totalPages) {
                if (currentPage + 1 === totalPages) { setDisplayReviewPage(true) }
                if (currentPage < totalPages) { setCurrentPage(currentPage + 1) }
            }
            if (event.key === 'ArrowLeft' && displayReviewPage) {
                setDisplayReviewPage(false);
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    });

    const fetchImagesForRating = async () => {
        setIsLoading(true);
        let response = await authorizedHttpGet("images/fetch_images_for_rating", { "gender": gender, "page": apiPageChange })
        if (response.status) {
            setImages(response.data.response)
            apiPage.current = response.data.page;
            apiTotalPages.current = response.data.total_pages;
        }
        setIsLoading(false);
    };

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        } else if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
        if (images.length === currentPage) {
            setDisplayReviewPage(true);
        }
        if (displayReviewPage && direction === 'prev') {
            setDisplayReviewPage(false);
        }
    };



    const handleGenderChange = (gen) => {
        setGender(gen);
        setCurrentPage(1);
    }

    useEffect(() => {
        setDisplayReviewPage(false);
        setCurrentPage(1);
        fetchImagesForRating();
    }, [gender, apiPageChange, appName]);

    const goToPage = (pageNumber) => {
        if (pageNumber <= apiTotalPages.current && pageNumber >= 1) {
            setApiPageChange(pageNumber);
        }
        setTogglePageModal(false);
    }

    const closeModal = () => {
        setTogglePageModal(false);
    }

    const assignRating = (rating, type) => {
        const imageUrl = currentProfile[0].image_url;
        const existingObject = ratedImages.find(obj => obj.image_url === imageUrl);
        if (rating === 10) {
            setTenRatedImages([...tenRatedImages, { image_url: currentProfile[0].image_url, type: type }])
        }
        if (existingObject) {
            const newRatedImages = ratedImages.filter(obj => obj.image_url !== imageUrl);
            setRatedImages([...newRatedImages, { image_url: imageUrl, rating: rating, ref: currentProfile[0].ref }]);
        } else {
            setRatedImages([...ratedImages, { image_url: imageUrl, rating: rating, ref: currentProfile[0].ref }]);
        }
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
        if (currentPage === totalPages) {
            setDisplayReviewPage(true);
        }
    }

    const fetchAssignedRating = () => {
        if (currentProfile.length === 0) {
            return false;
        }
        const imageUrl = currentProfile[0].image_url;
        const existingObject = ratedImages.find(obj => obj.image_url === imageUrl);
        if (existingObject) {
            return existingObject.rating;
        }
        return false;
    }

    const saveRatings = async () => {
        setIsLoading(true);
        let response = await authorizedHttpPost("images/save_manual_ratings", { "ratings": ratedImages, "page": apiPageChange, "gender": gender })
        if (response.status) {
            setImages(response.data.response)
            apiPage.current = response.data.page;
            apiTotalPages.current = response.data.total_pages;
            setRatedImages([]);
            setDisplayReviewPage(false);
            setCurrentPage(1);
        }
        setIsLoading(false);
    }

    return (
        <div className='App'>
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Rate Images'} />
            <div className='imageDivImageRating'>
                {isLoading && <Loader loading={isLoading} />}
                <FlexWrapper className='marginTop25'>
                    <HeaderWrapper className='cursorPointer' onClick={() => setTogglePageModal(true)}>
                        <HeaderSelected className='marginLeft10'>{apiPage.current}</HeaderSelected>
                        <HeaderSelected className='marginLeft10'>{apiTotalPages.current}</HeaderSelected>
                        <HeaderSelected className='marginLeft10'>{currentPage}</HeaderSelected>
                    </HeaderWrapper>
                    <HeaderWrapper >
                        <HeaderTextView marginRight cursor selected={gender === 'Male'} onClick={() => handleGenderChange('Male')}>Male</HeaderTextView>
                        <HeaderTextView selected={gender === 'Female'} cursor onClick={() => handleGenderChange('Female')}>Female</HeaderTextView>
                    </ HeaderWrapper>
                </FlexWrapper>
                {
                    images.length > 0 ? (
                        displayReviewPage ? <div>
                            {
                                <div className='imageRatingInfoDiv'>
                                    {ratedImages.map((image, index) => (
                                        <div key={index} className='margin10'>
                                            <img
                                                className='borderRadius50'
                                                width={100}
                                                height={100}
                                                src={image.image_url}
                                                alt={`Image ${index}`}
                                            />
                                            <br />
                                            <span>{image.rating}</span>
                                            <br />
                                            <span>{image.ref}</span>
                                        </div>
                                    ))}
                                </div>
                            }
                            <BaseButton onClick={() => saveRatings()}>Save</BaseButton>
                        </div> :

                            (<>
                                {togglePageModal && <PageModal goToPage={goToPage} page={apiPageChange} closeModal={closeModal} />}
                                <div className='ratingNumberDiv'>
                                    {
                                        ratings.map((rating) => (
                                            <CircleStyle selected={rating === fetchAssignedRating()} key={rating} onClick={() => assignRating(rating, 'click')}>
                                                {rating}
                                            </CircleStyle>
                                        ))
                                    }
                                </div>
                                <div className='ratingNumberDiv1'>
                                    {
                                        decimalRatings.map((rating) => (
                                            <CircleStyle selected={rating === fetchAssignedRating()} key={rating} onClick={() => assignRating(rating, 'click')}>
                                                {rating}
                                            </CircleStyle>
                                        ))
                                    }
                                </div>
                                <div >
                                    {currentProfile[0] && <img className='borderRadius10' width={250} height={250} src={currentProfile[0].image_url} />}
                                    {currentProfile[0] && <p>Ref Id: {currentProfile[0].ref}</p>}
                                    {currentProfile[0] ? <BottomBarWrapper>
                                        {currentPage === 1 ? <img src={previous_inctive} className='cursorPointer' /> : <img src={previous_active} onClick={() => handlePageChange('prev')} className='cursorPointer' />}
                                        {currentPage === 10 ? <img className='cursorPointer marginLeft30' src={next_inactive} onClick={() => handlePageChange('next')} /> : <img className='cursorPointer marginLeft30' src={next_active} onClick={() => handlePageChange('next')} />}
                                    </BottomBarWrapper> : null}
                                </div>
                            </>)
                    ) : <EmptyView />

                }
            </div>
        </div>
    )
}

export default ImageRating;